import { AuthContext } from "../../Context/AuthContext";
import { useContext } from "react";
import { useQuery } from "react-query";

const FetchBroadcastMessage = () => {
  const { token, user } = useContext(AuthContext);

  const fetchAdminMessages = async () => {
    const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/messages/get-messages/${user.userId}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error("Failed to fetch admin messages");
    }

    const data = await response.json();

    if (!Array.isArray(data.messages)) {
      throw new Error("Admin messages is not an array");
    }

    return data.messages;
  };

  const { data: adminMessages, isLoading, isError } = useQuery(
    "adminMessages",
    fetchAdminMessages,
    { enabled: !!token && !!user?.userId }
  );

  return { adminMessages, isLoading, isError };
};

export default FetchBroadcastMessage;
